import React from 'react'
import { Row, Card } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'

import SubmitDocStyle from '../../styles/SubmitDocuments.module.css'

const PIPUploadResults = () => {
  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero className={`${SubmitDocStyle["EmptyHeaderHeroUploadDocs"]}`} minHeight={true} title="We have received your uploaded documents." />
        <div className={`${SubmitDocStyle["mi-pip-upload"]}`}>
          <Card>
            <Row className={`${SubmitDocStyle["description-success"]}`}>
              <span style={{  marginTop: '10px' }}>Thank you for uploading documents online. We have added them to your policy or quote.</span>
            </Row>
            <Row className={`${SubmitDocStyle["description-success"]}`}>
              <span>What’s next? Keep an eye on your email!</span>
            </Row>
            <Row className={`${SubmitDocStyle["description-success"]}`}>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', width: '100%' }}>
                <li style={{   marginLeft: '6%', color: 'black', fontWeight: 'normal', fontSize: '20px', textTransform: 'none', marginBottom: '12px'  }}>Your documents will be reviewed by CURE as soon as possible.</li>
                <li style={{   marginLeft: '6%', color: 'black', fontWeight: 'normal', fontSize: '20px', textTransform: 'none', marginBottom: '12px'  }}>If we need additional information, we will email you.</li>
              </ul>
            </Row>
            <Row className={`${SubmitDocStyle["description-success"]}`}>
              <span style={{ width:'100%' }}>Drive well.</span>
            </Row>
          </Card>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

PIPUploadResults.propTypes = {}

export default PIPUploadResults
